import { useState } from "react";
import { Link } from "react-router-dom";
import { Show } from "@clerk/react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "@/lib/api";

const NAV = [
  { href: "#services", label: "Services", id: "nav-services-link" },
  { href: "#specials", label: "Specials", id: "nav-specials-link" },
  { href: "#gallery", label: "Our Work", id: "nav-gallery-link" },
  { href: "#before-after", label: "Before & After", id: "nav-before-after-link" },
  { href: "#book", label: "Book a Visit", id: "nav-book-link" },
  { href: "#estimate", label: "Free Estimate", id: "nav-estimates-link" },
];

const PortalBtn = () => (
  <>
    <Show when="signed-out">
      <Link to="/sign-in" data-testid="nav-customer-portal-btn" className="rounded-full bg-[#F2B91C] px-4 py-2 text-sm font-bold text-[#0E1F3F] transition-colors hover:bg-white">Portal Login</Link>
    </Show>
    <Show when="signed-in">
      <Link to="/portal" data-testid="nav-employee-portal-btn" className="rounded-full bg-[#F2B91C] px-4 py-2 text-sm font-bold text-[#0E1F3F] transition-colors hover:bg-white">My Portal</Link>
    </Show>
  </>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#0E1F3F]/95 backdrop-blur-md">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-3">
          <img src="/brand/logo.png" alt="Firm Foundations Construction LLC" className="h-14 w-auto" data-testid="header-logo" />
        </Link>
        <nav className="hidden items-center gap-6 lg:flex">
          {NAV.map((n) => (
            <a key={n.id} href={n.href} data-testid={n.id} className="text-sm font-medium text-white/80 transition-colors hover:text-[#F2B91C]">{n.label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={BUSINESS.phoneHref} data-testid="nav-phone-link" className="hidden items-center gap-1.5 text-sm font-semibold text-white xl:flex"><Phone size={14} className="text-[#F2B91C]" />{BUSINESS.phone}</a>
          <PortalBtn />
          <button className="text-white lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">{open ? <X /> : <Menu />}</button>
        </div>
      </div>
      {open && (
        <nav className="flex flex-col gap-1 border-t border-white/10 px-4 pb-4 lg:hidden" data-testid="nav-mobile-menu">
          {NAV.map((n) => <a key={n.id} href={n.href} onClick={() => setOpen(false)} className="py-2 text-white/85">{n.label}</a>)}
          <a href={BUSINESS.phoneHref} className="py-2 font-semibold text-[#F2B91C]">Call {BUSINESS.phone}</a>
        </nav>
      )}
    </header>
  );
};
